<template>
  <!-- 商品工作台 -->
  <div class="commodity-work-bench">
    <div class="commodity-work-bench-left">
      <div class="work-bench-left-top">
        <div class="filter-area">
          <Select v-model="selectValue">
            <Option v-for="(item,index) in option" :key="index" :value="item.value">{{item.label}}</Option>
          </Select>
        </div>
        <div class="commodity-manage-list">
          <div class="sale-list-item" v-for="(item,index) in saleListConfig" :key="index">
            <div class="sale-icon">
              <img :src="item.url" :width="item.img_width" :height="item.img_height" />
            </div>
            <div class="sale-target-content">
              <div
                class="content-item"
                v-for="(contentItem,acindex) in item.content"
                :key="acindex"
              >
                <p>{{contentItem.value}}</p>
                <span>{{contentItem.label}}</span>
              </div>
            </div>
          </div>
        </div>
        <!-- <sale-list :saleListConfig='saleListConfig'></sale-list>  -->
      </div>
      <div class="work-bench-left-bottom">
        <div class="filter-area">
          <Select v-model="selecttime">
            <Option
              v-for="(item,index) in Timeoption"
              :key="index"
              :value="item.value"
            >{{item.label}}</Option>
          </Select>
        </div>
        <div class="table-wrap">
          <div class="table-item" v-for="(value,key) in tableData" :key="key">
            <stor-table :sortTableConfig="value"></stor-table>
          </div>
        </div>
      </div>
    </div>
    <div class="commodity-work-bench-right">
      <div class="work-bench-right-top">
        <info-list :info="saleInfo"></info-list>
      </div>
      <div class="work-bench-right-bottom">
        <info-list :info="publicInfo"></info-list>
      </div>
    </div>
  </div>
</template>
<script>
import storTable from "commonCrumb/workBench/storTable.vue";
import infoList from "commonCrumb/workBench/infoList.vue";

export default {
  components: {
    storTable,
    infoList
  },
  data() {
    return {
      selectValue: 5,
      option: [
        {
          label: "所有",
          value: 1
        },
        {
          label: "乔丹官方旗舰店",
          value: 2
        },
        {
          label: "百尚天猫店",
          value: 3
        },
        {
          label: "乔丹儿童专卖店",
          value: 4
        },
        {
          label: "百尚、乔丹、儿童",
          value: 5
        }
      ],
      selecttime: 1,
      Timeoption: [
        {
          label: "近3天",
          value: 1
        },
        {
          label: "近7天",
          value: 2
        },
        {
          label: "近一个月",
          value: 3
        }
      ],
      saleListConfig: [
        {
          url: require("commonImages/workBench/1.png"), //图片的url
          img_width: 30, //图片的宽
          img_height: 30, //图片的搞
          //width:'4.8', //栅格布局布局中
          content: [
            {
              value: 65654,
              label: "待入库调拨单"
            }
          ]
        },
        {
          url: require("commonImages/workBench/1.png"), //图片的url
          img_width: 30, //图片的宽
          img_height: 30, //图片的搞
          //width:'4.8', //栅格布局布局中
          content: [
            {
              value: 878485,
              label: "昨日销售总额"
            }
          ]
        },
        {
          url: require("commonImages/workBench/1.png"), //图片的url
          img_width: 30, //图片的宽
          img_height: 30, //图片的搞
          //width:'4.8', //栅格布局布局中
          content: [
            {
              value: 7844888,
              label: "昨日销售总额"
            }
          ]
        },
        {
          url: require("commonImages/workBench/1.png"), //图片的url
          img_width: 30, //图片的宽
          img_height: 30, //图片的搞
          //width:'4.8', //栅格布局布局中
          content: [
            {
              value: 158811,
              label: "昨日销售总额"
            }
          ]
        },
        {
          url: require("commonImages/workBench/1.png"), //图片的url
          img_width: 30, //图片的宽
          img_height: 30, //图片的搞
          //width:'4.8', //栅格布局布局中
          content: [
            {
              value: 788995,
              label: "昨日销售总额"
            }
          ]
        }
      ],
      saleInfo: {
        icon: "md-appstore",
        size: "30",
        color: "",
        custom: "",
        title: "促销活动",
        width: "200px",
        height: "500px",
        infos: [
          "京东双12前30分钟买一送一",
          "天猫冰雪节399赠送袜子",
          "京东圣诞节鞋子送袜子",
          "双12天猫满599随机赠送礼"
        ]
      },
      publicInfo: {
        icon: "ios-megaphone",
        size: "30",
        color: "",
        custom: "",
        title: "公告活动",
        width: "200px",
        height: "500px",
        infos: [
          "京东双12前30分钟买一送一",
          "天猫冰雪节399赠送袜子",
          "京东圣诞节鞋子送袜子",
          "双12天猫满599随机赠送礼"
        ]
      },
      tableData: [
        {
          ranking: true,
          product: true,
          columns: [
            {
              title: "销售金额",
              key: "xsje"
            }
          ],
          data: [
            {
              commodity: {
                text: "乔丹",
                src: require("commonImages/workBench/1.png")
              },
              xsje: 178
            },
            {
              xsje: 263
            },
            {
              xsje: 700
            }
          ],
          //dashedColor: "red", //默认红色, green:绿色  只有titleStyle为border时生效
          title: "近七日畅销商品 金额TOP榜",
          titleStyle: "border" //标题样式 default正常样式 border:带边框有颜色样式
        },
        {
          ranking: true,
          product: true,
          columns: [
            {
              title: "销售数量",
              key: "xsje"
            }
          ],
          data: [
            {
              commodity: {
                text: "乔丹",
                src: require("commonImages/workBench/1.png")
              },
              xsje: 200
            },
            {
              xsje: 500
            },
            {
              xsje: 600
            }
          ],
          dashedColor: "green", //默认红色, green:绿色  只有titleStyle为border时生效
          title: "近7日畅销商品 数量TOP榜",
          titleStyle: "border" //标题样式 default正常样式 border:带边框有颜色样式
        },
        {
          ranking: true,
          product: false,
          columns: [
            {
              title: "商品链接",
              key: "splj"
            },
            {
              title: "成交数量",
              key: "cjsl"
            }
          ],
          data: [
            {
              splj:
                "乔丹男鞋鞋子运动鞋男2018新款冬季保暖男跑鞋轻便休闲透气跑步鞋",
              cjsl: "123"
            },
            {
              splj:
                "乔丹男鞋鞋子运动鞋男2018新款冬季保暖男跑鞋轻便休闲透气跑步鞋",
              cjsl: "3214"
            },
            {
              splj:
                "乔丹男鞋鞋子运动鞋男2018新款冬季保暖男跑鞋轻便休闲透气跑步鞋",
              cjsl: "7854"
            }
          ],
          dashedColor: "blue", //默认红色, green:绿色  只有titleStyle为border时生效
          title: "近7日畅销商品链接 TOP榜",
          titleStyle: "border" //标题样式 default正常样式 border:带边框有颜色样式
        }
      ]
    };
  }
};
</script>
<style lang="less">
.commodity-work-bench {
  padding: 8px 12px;
  display: flex;
  display: -webkit-flex;
  .commodity-work-bench-left {
    width: 80%;
    .filter-area {
      margin-bottom: 20px;
      text-align: right;
      .ark-select {
        width: 200px;
      }
    }
    .commodity-manage-list {
      overflow: hidden;
      width: 100%;
      .sale-list-item {
        box-sizing: border-box;
        float: left;
        width: 20%;
        display: -webkit-flex; /* Safari */
        display: flex;
        border: 1px solid #ccc;
        border-right: none;
        &:last-child {
          border-right: 1px solid #ccc;
        }
        .sale-icon {
          flex: 1;
          display: -webkit-flex;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
          }
        }
        .sale-target-content {
          flex: 2;
          box-sizing: border-box;
          display: -webkit-flex; /* Safari */
          display: flex;
          flex-direction: column;
          .content-item {
            padding: 8px 12px;
            border-bottom: 1px solid #ccc;
            text-align: center;
            p {
              font-size: 14px;
              line-height: 30px;
              color: #fd6442;
              &:hover {
                font-weight: 600;
              }
            }
            span {
              line-height: 30px;
            }
            &:last-child {
              border-bottom: none;
            }
          }
        }
      }
    }
    .work-bench-left-bottom {
      margin-top: 20px;
      .table-wrap {
        display: flex;
        display: -webkit-flex;
        .table-item {
          margin-right: 12px;
          flex: 1;
          .sortTable {
            table {
              width: 100%;
            }
          }
          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
  }
  .commodity-work-bench-right {
    display: flex;
    display: -webkit-flex;
    flex-direction: column;
    align-items: center;
    width: 20%;
    .work-bench-right-top {
      flex: 2;
    }
    .work-bench-right-bottom {
      flex: 3;
    }
  }
}
</style>


